import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
    name: 'monthlyTicketMultiple',
    initialState: {
        isRequesting: false,
        error: null,
        isDone: false,
        data: null,
    },
    reducers: {
        reset_data: (state) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: false,
                data: null,
            };
        },
        create_monthly_ticket_multiple: (state) => {
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_monthly_ticket_multiple: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        update_monthly_ticket_multiple: (state) =>{
            return {
                ...state,
                isRequesting: true,
                isDone: false,
                error: null,
            };
        },
        delete_monthly_ticket_multiple_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        update_monthly_ticket_multiple_failed: (state,action) =>{
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        create_monthly_ticket_multiple_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                isDone: true,
                error: action.payload,
                data: null
            };
        },
        delete_monthly_ticket_multiple_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        update_monthly_ticket_multiple_succeed: (state) =>{
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
            };
        },
        create_monthly_ticket_multiple_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                isDone: true,
                data: action.payload
            };
        },
    }
});

export const { reducer, actions } = slice;

export default reducer;